import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Lock } from "lucide-react";

export const ProjectCard = ({ project, large = false, index = 0 }) => {
  return (
    <motion.div
      data-testid="project-card"
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.55, delay: (index % 4) * 0.06 }}
      className="group"
    >
      <Link
        to={`/projects/${project.slug}`}
        data-testid={`project-link-${project.slug}`}
        className="block h-full rounded-2xl border border-black/5 bg-white overflow-hidden card-shadow hover:-translate-y-1 transition-transform duration-300"
      >
        <div className={`relative overflow-hidden ${large ? "aspect-[16/10]" : "aspect-[16/11]"}`}>
          <img
            src={project.cover_image}
            alt={project.title}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
          {project.anonymized && (
            <span className="absolute top-3 left-3 inline-flex items-center gap-1 rounded-full bg-white/90 backdrop-blur px-2.5 py-1 text-[10px] font-mono uppercase tracking-widest text-primary">
              <Lock size={10} /> Anonymized
            </span>
          )}
        </div>
        <div className="p-6">
          <div className="flex flex-wrap gap-2 mb-3">
            {(project.tags || []).slice(0, 3).map((t) => (
              <span key={t} className="rounded-full bg-secondary text-primary font-mono text-[10px] uppercase tracking-widest px-2.5 py-1">
                {t}
              </span>
            ))}
          </div>
          <h3 className={`font-serif text-foreground leading-tight ${large ? "text-2xl md:text-3xl" : "text-xl"}`}>
            {project.title}
          </h3>
          <p className="mt-3 text-foreground/60 leading-relaxed line-clamp-3">{project.summary}</p>
          {project.role && (
            <div className="mt-4 text-xs text-foreground/50">
              <span className="font-mono uppercase tracking-widest text-primary/70">Role</span> · {project.role}
            </div>
          )}
          <div className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-primary">
            View Case Study
            <ArrowUpRight size={15} className="transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </div>
        </div>
      </Link>
    </motion.div>
  );
};
